<template>
  <dl
    class="flex justify-between align-top pl-3 gap-2"
    :class="getSubitemClasses(subitem.Type)"
   
  >
    <dt class="min-w-0">
      <span class="flex items-center gap-2 min-w-0">
        <span
          class="wrap-anywhere min-w-0"
         
        >
          {{ subitem.Label?.[localeKey] }}
        </span>

        <TTooltipIcon
          v-if="subitem.Description"
          :title="subitem.Label?.[localeKey] ?? ''"
          :content="subitem.Description?.[localeKey]"
          icon-variant="muted"
          modal-type="critical"
        />
      </span>

      <div
        v-if="subitem.Type === 'PromoCode'"
        class="mt-1"
      >
        <slot
          name="promo-code-badge"
          :subitem="subitem"
        />
      </div>
    </dt>
    <dd
     
      class="text-right"
    >
      {{ subitem.Value?.[localeKey] }}
    </dd>
  </dl>
</template>

<script setup lang="ts">
import type { BookingPriceBreakdownItem } from '~/types'

defineProps<{
  subitem: BookingPriceBreakdownItem
}>()

const { localeKey } = useLocaleKey()

function getSubitemClasses(type: BookingPriceBreakdownItem['Type']) {
  switch (type) {
    case 'Discount':
    case 'PromoCode':
      return 'text-secondary/85'
    default:
      return 'text-gray-400'
  }
}
</script>
